export const initialFilterValues = {
    reference: '',
    amountDueFrom: null,
    amountDueTo: null,
    originalAmountFrom: null,
    originalAmountTo: null,
    dateFrom: undefined,
    dateTo: undefined,
    dueDateFrom: undefined,
    dueDateTo: undefined,
};
